import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import "./Filterbar.css";

const SearchInputContainer = styled.div`
  ${"" /* position:fixed; */}
  ${"" /* width:100%; */}
`;
const SearchInput = styled.input`
  width: 100%;
  padding: 8px;
  borderleft: none;
`;
const SelectAllCheckbox = styled.input`
  padding: 3px;
  margin-top:5px;
  margin-right:5px;

`;

// Showing the center list as a multiselection drop down

const Centerlist = ({
  center_list,
  closeModal,
  showCenterList,
  setShowCenterList,
  selectedCenterIdsList,
  selectedCenterIdsHandler,
}) => {
  
  const centerListRef = useRef({
    selectedCenterList: [],
  });
  //
  if (center_list !== "" && center_list !== null) {
    center_list.sort(function (a, b) {
      var textA = a.center_name?.toUpperCase();
      var textB = b.center_name?.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  }
  const [centerList, setCenterList] = useState([]);
  const [storedSelectedCenterList, setStoredSelectedCenterList] = useState([]);
  const [selectAllCenterCheckboxStatus, SetSelectAllCenterCheckboxStatus] = useState(false);

  useEffect(() => {
    if (Array.isArray(center_list)) {
      setCenterList(center_list);
      setStoredSelectedCenterList(center_list);
      console.log("center_list-1",center_list)
    }
  }, [center_list]);



  const { CenterListCallHistory } = useSelector((state) => state);

  const dispatch = useDispatch();

  let modalRef = null;
  const handleClose = (e) => {
    if (modalRef && !modalRef.contains(e.target)) {
      closeModal();
    }
  };

// Resetting the selected value 
  useEffect(()=>{
    if(Array.isArray(selectedCenterIdsList) && !selectedCenterIdsList.length){
      let centers=centerList.map((item)=>{
        return {
          ...item,
          isChecked:false
        }
      })
      setCenterList(centers)
      centerListRef.current.selectedCenterList=[]

    }

  },[selectedCenterIdsList])

  
  const CheckBoxHandler = (option) => {
    let selectedCenters = centerListRef?.current?.selectedCenterList;
    let centersList = centerList;
    let idx = centersList.findIndex(
      (item) => parseInt(item.center_id) === parseInt(option.center_id)
    );
    let data = centersList[idx];
    if (centersList[idx].isChecked) {
      data = {
        ...data,
        isChecked: false,
      };
      selectedCenters = selectedCenters.filter(
        (item) => parseInt(item) !== parseInt(centersList[idx].center_id)
      );
    } else {
      data = {
        ...data,
        isChecked: true,
      };
      selectedCenters.push(parseInt(option.center_id));
    }

    centersList[idx] = data;
    setCenterList(() => [...centersList]);
    centerListRef.current.selectedCenterList = selectedCenters;
    selectedCenterIdsHandler(() => [...selectedCenters]);
    SetSelectAllCenterCheckboxStatus(checkSelectedAll(centersList,selectedCenters))
   };


//  This function verifies if all filtered centers  are marked as active.then set select-all-centers value select all or unselect all .
  const checkSelectedAll=(centersList,selectedCenters)=>{
    let selected_center_count_in_filtered_center=0 ;
    centersList.map((center_obj)=>{
      selectedCenters.map((center_id)=>{
        if(center_id==center_obj.center_id){selected_center_count_in_filtered_center++;}
        return ;
      })
      return center_obj ;
    })

    if(selected_center_count_in_filtered_center==centersList.length && selected_center_count_in_filtered_center!=0){
      return true
    }else{
      return false
    }
   };  
  

// This function will return the filtered centers list. Then, for each object in the filtered list, it will set the 'isChecked' status based on the selectedCenters list.
  const searchInputHandler = (e) => {
    let selectedCenters = centerListRef?.current?.selectedCenterList;
    let storedCenterList=storedSelectedCenterList.map((center_data)=>{
      return {...center_data,isChecked:false}
    })
    if (!e.target.value) {
      if (selectedCenterIdsList?.length > 0) {
        //If there is any selected option then make it checked
        let filteredCenterList = storedCenterList.map((item) => {
          let final_item=item ;
          selectedCenters.map((selected_center)=>{
            if(selected_center==item?.center_id){
              final_item = { ...item, isChecked: true }
            }
            return selected_center;
          } )
          return final_item;
        });
        setCenterList([...filteredCenterList]);
        SetSelectAllCenterCheckboxStatus(checkSelectedAll(filteredCenterList,selectedCenters))
      } else {
        setCenterList([...storedCenterList]);
        SetSelectAllCenterCheckboxStatus(checkSelectedAll(storedCenterList,selectedCenters))
      }
    } else {
      let filteredData = storedCenterList.filter(
        (item) =>
          item.center_name
            .toLowerCase()
            .includes(e.target.value.trim().toLowerCase()) ||
          item.center_prefix
            ?.toLowerCase()
            .includes(e.target.value.trim().toLowerCase())
      );
      if (selectedCenterIdsList.length >0) {
        let filteredCenterList = filteredData.map((item) => {
          let final_item=item ;
          selectedCenters.map((selected_center)=>{
            if(selected_center==item?.center_id){
              final_item = { ...item, isChecked: true }
            }
            return selected_center;
          } )
          return final_item;
        });
        setCenterList([...filteredCenterList]);
        SetSelectAllCenterCheckboxStatus(checkSelectedAll(filteredCenterList,selectedCenters))
      } else {
        setCenterList([...filteredData]);
        SetSelectAllCenterCheckboxStatus(checkSelectedAll(filteredData,selectedCenters))
      }
    }
  };



// This function takes the 'selectAllCenter' argument, which represents the status of the select all centers checkbox/event. Depending on this value, it will either add or remove values from the selected centers list and updated the centers list.
const selectAllCenterHandler = (selectAllCenter) => {
    let selectedCenters = centerListRef?.current?.selectedCenterList;
    let updated_centers_List = centerList; 
    updated_centers_List=updated_centers_List.map((center_obj)=>{
       let is_center_selected=false ;
      selectedCenters.map((selected_center_id)=>{
         if(selected_center_id==center_obj.center_id){
          is_center_selected=true ;
         }
      })
      if(!is_center_selected && selectAllCenter){
        selectedCenters.push(parseInt(center_obj.center_id))
        return {...center_obj,isChecked:selectAllCenter}
      }
      if(is_center_selected && !selectAllCenter){
        selectedCenters = selectedCenters.filter(
          (item) => parseInt(item) !== parseInt(center_obj.center_id)
        );
        return {...center_obj,isChecked:selectAllCenter}
      }
      return center_obj
    })
    selectedCenterIdsHandler(() => [...selectedCenters]);
    centerListRef.current.selectedCenterList = selectedCenters;
    setCenterList(() => [...updated_centers_List]);
  }

  return (
    <div className="modal-box" ref={(node) => (modalRef = node)}>
      <div
        className="centerList"
        style={{ borderBottom: "none", position: "relative" }}
      >
        <SearchInputContainer>
          <div style={{display:"flex",gap:"5px",backgroundColor:"white",border:"1px solid black",borderLeft:"0px",borderTop:"0px"}}>
            <SearchInput
            style={{border:"0px solid transparent"}}
            placeholder="Search center.."
            onChange={searchInputHandler}
          />
          </div>
          
        </SearchInputContainer>
     <div style={{display:"flex",paddingTop:"10px"}}>
            <div
              style={{
                color: "blue",
                padding: "2px 2px 2px 12px",
                cursor: "pointer",
              }}
              onClick={() => {
                selectAllCenterHandler(true);
              }}
            >
               Select all
            </div>
            <div
              style={{
                color: "blue",
                padding: "2px 2px 2px 2px",
                cursor: "pointer"
              }}
            >
            -
            </div>
            <div
              style={{
                color: "blue",
                padding: "2px",
                cursor: "pointer"
              }}
              onClick={() => {
                selectAllCenterHandler(false);
              }}
            >
             Unselect all
            </div>
            </div>
        {Array.isArray(centerList) &&
          centerList.map((item) => {
            return (
              <div style={{ marginTop: "10px", marginBottom: "-10px" }} key={item.center_prefix}>
                <div
                  style={{
                    display: "flex",
                    justifyItems: "center",
                    marginBottom: "10px",
                    width: "200px",
                    padding: "0px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ marginRight: "15px" }}>
                      <input
                        type="checkbox"
                        // value={item.center_id}
                        checked={item.isChecked}
                        className="callstatusChecbox"
                        style={{ marginLeft: "15px" }}
                        onChange={(e) => CheckBoxHandler(item)}
                      />
                    </div>
                    <div style={{ color: "black" }}>
                      {item.center_name} ({item.center_prefix})
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      <div
        className="modalCloseBtn"
        style={{padding:"2px"}}
        onClick={() => {
          if (showCenterList.length) {
            setShowCenterList("");
          } else {
            setShowCenterList("none");
          }
        }}
      >
        Done {selectedCenterIdsList.length==0?"":` (${selectedCenterIdsList.length} Selected)`}
      </div>
    </div>
  );
};

export default Centerlist;
